<template>
  <div class="ab-customs-superiority">
    <AbBlock
      title="为什么选择AB客海关数据"
      subTitle="集买卖家查找与市场分析为一体"
    >
      <a-tabs
        default-active-key="1"
        forceRender
        size="large"
        tab-position="left"
      >
        <a-tab-pane key="1" tab="全球海关数据">
          <div class="superiority-pane">
            <img src="~@/assets/product/全球海关数据.png" alt="全球海关数据" />
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="个性化查询方式">
          <div class="superiority-pane">
            <img
              src="~@/assets/product/个性化查询方式.png"
              alt="个性化查询方式"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="详细的提单信息">
          <div class="superiority-pane">
            <img
              src="~@/assets/product/详细的提单信息.png"
              alt="详细的提单信息"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" tab="AI智能开发客户">
          <div class="superiority-pane">
            <img
              src="~@/assets/product/AI智能开发客户.png"
              alt="AI智能开发客户"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane key="5" tab="外贸客户管理">
          <div class="superiority-pane">
            <img src="~@/assets/product/外贸客户管理.png" alt="外贸客户管理" />
          </div>
        </a-tab-pane>
        <a-tab-pane key="6" tab="可视化分析报表">
          <div class="superiority-pane">
            <img
              src="~@/assets/product/可视化分析报表.png"
              alt="可视化分析报表"
            />
          </div>
        </a-tab-pane>
      </a-tabs>
    </AbBlock>
  </div>
</template>

<script>
import AbBlock from '@/components/AbBlock.vue';
export default {
  components: {
    AbBlock,
  },
  data() {
    return {};
  },
};
</script>

<style lang="sass" scoped>
.ab-customs-superiority{
  height: 900px;
  width: 100%;
  padding-top: 80px;
  padding-bottom: 92px;

  // ::v-deep .ant-tabs-tab{
  //   width: 460px;
  //   height: 80px;
  //   background: #EAEFF7;
  //   border-radius: 4px;
  //   font-size: 20px;
  //   font-family: AlibabaPuHuiTiM;
  //   font-weight: normal;
  //   color: #333646;
  //   line-height: 80px;
  //   text-align: left;
  // }


  .superiority-pane{
    width: 100%;
    height: 100%;
    overflow: hidden;//img如果超出这个div会隐藏超出部分
    display: flex;//flex布局
    align-items: center;//让img放在div的中间，居中

    > img{
      // width: 888px;
      // height: 536px;
      width: 100%;
      // height: 100%;
    }
  }
}
</style>
